enum EconsentContactType {
  EMAIL = 'EMAIL',
  SMS = 'SMS',
}

export default EconsentContactType;
